import { LoadState } from "../../constants/enums";
import { ICatalogsState } from "./Catalogs.types";

export const initialCatalogsState: ICatalogsState = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
  },
};
